export class LeastRecentUsedCache {
    private values: Map<string, string> = new Map<string, string>();

    // tslint:disable-next-line:no-empty
    constructor(private maxEntries: number = 300) {}

    public get(key: string): string {
        const hasKey = this.values.has(key);
        let entry: string;
        if (hasKey) {
            // peek the entry, re-insert for LRU strategy
            entry = this.values.get(key);
            this.values.delete(key);
            this.values.set(key, entry);
            return entry;
        }
        return undefined;
    }

    public put(key: string, value: string) {
        if (this.values.size >= this.maxEntries) {
            // least-recently used cache eviction strategy
            const keyToDelete = this.values.keys().next().value;
            this.values.delete(keyToDelete);
        }
        if (typeof this.values.get(key) === "undefined") {
            this.values.set(key, value);
        }
    }

    public clear() {
        this.values.clear();
    }
}
